import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { withVars, toLength } from "./styleVars.js";
const Skeleton = React.forwardRef(function Skeleton2({ width, height, circle = false, className, style, ...rest }, ref) {
  const w = width != null ? toLength(width) : circle && height != null ? toLength(height) : void 0;
  const h = height != null ? toLength(height) : circle && width != null ? toLength(width) : void 0;
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      "aria-hidden": "true",
      className: cx("ev-skeleton", className),
      "data-shape": circle ? "circle" : void 0,
      style: withVars(style, { "--ev-skeleton-width": w, "--ev-skeleton-height": h }),
      ...rest
    }
  );
});
export {
  Skeleton
};
//# sourceMappingURL=Skeleton.js.map
